import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const ChapterList = () => {
  const [chapters, setChapters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchChapters = async () => {
      try {
        const response = await axios.get("/api/chapters");
        setChapters(response.data);
      } catch (err) {
        setError("Error loading chapters");
        console.error("Error fetching chapters:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchChapters();
  }, []);

  const handleDelete = async (chapterId, chapterTitle) => {
    if (
      window.confirm(
        `Are you sure you want to delete the chapter "${chapterTitle}"? This action cannot be undone.`
      )
    ) {
      try {
        await axios.delete(`/api/chapters/${chapterId}`);
        // Refresh the chapter list
        const response = await axios.get("/api/chapters");
        setChapters(response.data);
      } catch (err) {
        setError("Error deleting chapter");
        console.error("Error deleting chapter:", err);
      }
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen bg-sacred-white">
        Loading...
      </div>
    );
  if (error)
    return (
      <div className="text-earth-red text-center p-4 bg-sacred-white">
        Error: {error}
      </div>
    );

  return (
    <div className="min-h-screen bg-sacred-white py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-obsidian-black mb-4">
            Chapter List
          </h1>
        </div>

        <div className="space-y-6">
          {chapters.map((chapter) => (
            <div
              key={chapter.id}
              className="bg-sacred-white shadow rounded-lg p-6 flex items-center justify-between hover:shadow-lg transition-shadow duration-200 border border-sage-green"
            >
              <Link
                to={`/chapter/${chapter.id}`}
                className="text-xl font-semibold text-obsidian-black hover:text-canyon-stone transition-colors duration-200"
              >
                {chapter.title}
              </Link>
              <div className="flex space-x-4">
                <Link
                  to={`/chapter/${chapter.id}/edit`}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-sacred-white bg-turquoise-green hover:bg-sky-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-turquoise-green"
                >
                  Edit Chapter
                </Link>
                <button
                  onClick={() => handleDelete(chapter.id, chapter.title)}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-sacred-white bg-earth-red hover:bg-canyon-stone focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-earth-red"
                >
                  Delete Chapter
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/chapter/new/edit"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-sacred-white bg-turquoise-green hover:bg-sky-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-turquoise-green"
          >
            Add New Chapter
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChapterList;
